import styled from '@emotion/styled';
import {colors, fonts, mq} from 'ui/config';
import {Img, MainTitle as MainTitleUI, HeadlineMedium} from 'ui';
import {Link} from 'react-router-dom';
import arrowBack from 'assets/img/arrowBack.svg';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'center',
  marginBottom: 40,
  paddingBottom: 40,
});

export const FormationCover = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  width: '100vw',
  height: 350,
});

export const FormationContent = styled('div')({
  padding: 20,
  backgroundColor: colors.greyLight,
});

export const Image = styled(Img)({
  width: '100vw',
  height: 350,
});

export const BackLink = styled(Link)({
  position: 'absolute',
  top: 40,
  left: 20,
  width: 32,
  height: 32,
  backgroundColor: 'transparent',
  backgroundImage: `url(${arrowBack})`,
  backgroundPosition: 'center',
});

export const MainTitle = styled(MainTitleUI)({
  position: 'absolute',
  left: 0,
  bottom: 66,
  zIndex: 10,
  width: '100%',
});

export const DateBlock = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: colors.caramel,
  position: 'absolute',
  top: 130,
  width: 136,
  height: 45,
  fontFamily: fonts.title,
  color: colors.white,
  fontWeight: 'bold',
  outline: `2px solid ${colors.caramel}`,
  border: `1px solid ${colors.white}`,
});

export const BodyTitle = styled('div')({
  paddingLeft: 20,
  paddingRight: 20,
  fontFamily: fonts.title,
  fontSize: 26,
  color: colors.caramel,
  fontWeight: 'bold',
  marginTop: 30,
  marginBottom: 35,
});

export const BodyText = styled('div')({
  paddingLeft: 20,
  paddingRight: 20,
  color: colors.grey,
  fontSize: 16,
  '& p > span': {
    color: colors.grey,
    fontFamily: fonts.title,
  },
  '& p > a': {
    color: colors.grey,
    fontFamily: fonts.title,
  },
});

export const InfoBlock = styled('div')({
  backgroundColor: colors.white,
  fontFamily: fonts.title,
  fontSize: 16,
  color: colors.grey,
  marginTop: 30,
  marginLeft: 20,
  marginRight: 20,
  marginBottom: 35,
  paddingTop: 16,
  paddingBottom: 16,
  paddingLeft: 30,
  borderLeft: `10px solid ${colors.caramel}`,
  lineHeight: 2,
});

export const BodySubTitle = styled('div')({
  paddingLeft: 20,
  paddingRight: 20,
  fontSize: 16,
  color: colors.caramel,
});

export const Mask = styled('div')({
  position: 'absolute',
  left: 0,
  bottom: 0,
  width: '100%',
  height: 97,
  backgroundImage: 'linear-gradient(180deg, rgba(56,40,24,0.00) 0%, #382818 100%)',
});

export const MediumTitle = styled(HeadlineMedium)({
  position: 'absolute',
  marginLeft: 17,
  marginRight: 17,
  zIndex: 10,
  bottom: -10,
  [mq('compact')]: {
    bottom: -25,
  },
});
